import { useEffect } from "react";
import { useAuth } from "./contexts/AuthContext";

export default function UserbackInit() {
  const { user } = useAuth();
  const userbackToken = (process.env.REACT_APP_USERBACK_TOKEN || "").trim();
  const lighthouseMode = typeof window !== "undefined" && window.__QS_LIGHTHOUSE_MODE__ === true;

  useEffect(() => {
    if (lighthouseMode) return;
    if (!userbackToken) return;
    if (!user) return;

    let cancelled = false;
    const options = user && user.email ? {
      user_data: {
        id: user.id || user.email,
        info: {
          name: user.nombre || user.name || "",
          email: user.email || ""
        }
      }
    } : {};

    const init = async () => {
      try {
        // Load third-party widget only when needed to reduce initial JS cost.
        const mod = await import("@userback/widget");
        if (cancelled) return;
        const Userback = mod?.default || mod;
        await Promise.resolve(Userback(userbackToken, options));
      } catch (error) {
        // Prevent unhandled promise rejections on invalid token/project config.
        console.error("[Userback] init failed:", error?.message || error);
      }
    };
    init();

    return () => {
      cancelled = true;
    };
  }, [user, userbackToken, lighthouseMode]);

  return null; // No renderiza nada
}
